import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import Item from "./Item";
import NotFoundV2 from "../NotFound/NotFoundV2";

class CollaboratorList extends Component {
  handleRedirectCollaborator = ({ id }) => {
    this.props.dispatch(push("/collaborator-space/" + id));
  };

  render() {
    const { fetched, items, synchro } = this.props;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          maxWidth: "1320px"
        }}
      >
        {fetched && items.length ? (
          items.map((item, i) => {
            return (
              <Item
                item={item}
                key={item ? `collaborator-${item.id}` : ""}
                handleRedirectCollaborator={this.handleRedirectCollaborator}
                synchro={synchro}
              />
            );
          })
        ) : (
          <NotFoundV2 />
        )}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetched: state.collaboratorList.fetched
});

export default connect(mapStateToProps)(CollaboratorList);



// WEBPACK FOOTER //
// ./src/components/Collaborator/CollaboratorList.js